import { isNil, isEmpty } from 'lodash'; 
const getters = {
  getLocal: (state) =>
  {
    return state.local;
  },

  getCategoryByCode: (state) => (code) =>
  {
    return state.allSettingsData.Categories.find((category) =>
    {
      category.Code == code;
    });
  },

  allowSettingsSend: (state) =>
  {
    // state.local.zones.length 
    return (
     !isEmpty(state.local.keywordsJD) && Object.keys(state.local.locations).length > 0
      // state.local.mainCategory &&
      // state.local.mainSubCategories && state.local.mainSubCategories.length 
      // && Object.keys(state.local.locations).length > 0
    );
  },

  removeReasons: (state) => (code) =>
  {
    return state.removeData.RemoveReasonMenu.Menu[code].SubMenu;
  },
};

export default getters;
